export const CycleEvaluationSteps = {
    DEFINE_AUDIENCE: 'DefineAudience',
    SELECT_EVALUATORS: 'SelectEvaluators',
    SELECT_TEMPLATE: 'SelectTemplate',
    QUESTIONNAIRE_CREATION: 'QuestionnaireCreation',
    SCHEDULE_CREATION: 'ScheduleCreation',
} as const;

export type CycleEvaluationStepsType =
    (typeof CycleEvaluationSteps)[keyof typeof CycleEvaluationSteps];
